// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderClaimEligibility,
    ProviderCreateClaimEligibilityPayload,
    ProviderEligibilitySortType,
    SupportClaimEligibility,
    SupportCreateClaimEligibilityPayload,
    SupportEligibilitySortType,
    SupportGenerateClaimEligibilityPayload,
    SupportReplaceEligibilityPayload,
    ProviderCreateClaimEligibilityPayloadToJSON,
    SupportCreateClaimEligibilityPayloadToJSON,
    SupportGenerateClaimEligibilityPayloadToJSON,
    SupportReplaceEligibilityPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderClaimEligibilityFromJSON,
    SupportClaimEligibilityFromJSON,
} from '../models';

export interface CreateProviderClaimEligibilityRequest {
    providerCreateClaimEligibilityPayload: ProviderCreateClaimEligibilityPayload;
}

export interface CreateProviderClaimEligibilityAsyncRequest {
    providerCreateClaimEligibilityPayload: ProviderCreateClaimEligibilityPayload;
}

export interface CreateSupportClaimEligibilityRequest {
    supportCreateClaimEligibilityPayload: SupportCreateClaimEligibilityPayload;
}

export interface GenerateSupportClaimEligibilityRequest {
    supportGenerateClaimEligibilityPayload: SupportGenerateClaimEligibilityPayload;
}

export interface GetProviderClaimEligibilityRequest {
    id: string;
}

export interface GetSupportClaimEligibilityRequest {
    id: string;
}

export interface ListProviderClaimEligibilitiesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClaimEligibilitiesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterClaimId?: Array<string>;
    filterPlanId?: Array<string>;
    filterGroupId?: Array<string>;
    filterTypeParameter?: Array<string>;
    sort?: Array<ProviderEligibilitySortType>;
}

export interface ListSupportClaimEligibilitiesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClaimEligibilitiesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterPlanId?: Array<string>;
    filterGroupId?: Array<string>;
    filterTypeParameter?: Array<string>;
    sort?: Array<SupportEligibilitySortType>;
}

export interface ReplaceSupportEligibilityRequest {
    supportReplaceEligibilityPayload: SupportReplaceEligibilityPayload;
}

/**
 * no description
 */
export class EligibilityApi extends runtime.BaseAPI {

    /**
     * Create a real-time eligibility check
     * Create a real-time eligibility check
     */
    async createProviderClaimEligibilityRaw(requestParameters: CreateProviderClaimEligibilityRequest): Promise<runtime.ApiResponse<ProviderClaimEligibility>> {
        if (requestParameters['providerCreateClaimEligibilityPayload'] === null || requestParameters['providerCreateClaimEligibilityPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateClaimEligibilityPayload','Required parameter requestParameters.providerCreateClaimEligibilityPayload was null or undefined when calling createProviderClaimEligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eligibility"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eligibility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateClaimEligibilityPayloadToJSON(requestParameters['providerCreateClaimEligibilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Create a real-time eligibility check
     * Create a real-time eligibility check
     */
    async createProviderClaimEligibility(requestParameters: CreateProviderClaimEligibilityRequest): Promise<ProviderClaimEligibility> {
        const response = await this.createProviderClaimEligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a real-time asynchronous eligibility check
     * Create a real-time asynchronous eligibility check
     */
    async createProviderClaimEligibilityAsyncRaw(requestParameters: CreateProviderClaimEligibilityAsyncRequest): Promise<runtime.ApiResponse<ProviderClaimEligibility>> {
        if (requestParameters['providerCreateClaimEligibilityPayload'] === null || requestParameters['providerCreateClaimEligibilityPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateClaimEligibilityPayload','Required parameter requestParameters.providerCreateClaimEligibilityPayload was null or undefined when calling createProviderClaimEligibilityAsync.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eligibility"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eligibility/async`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateClaimEligibilityPayloadToJSON(requestParameters['providerCreateClaimEligibilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Create a real-time asynchronous eligibility check
     * Create a real-time asynchronous eligibility check
     */
    async createProviderClaimEligibilityAsync(requestParameters: CreateProviderClaimEligibilityAsyncRequest): Promise<ProviderClaimEligibility> {
        const response = await this.createProviderClaimEligibilityAsyncRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a claim eligibility
     * Create a claim eligibility
     */
    async createSupportClaimEligibilityRaw(requestParameters: CreateSupportClaimEligibilityRequest): Promise<runtime.ApiResponse<SupportClaimEligibility>> {
        if (requestParameters['supportCreateClaimEligibilityPayload'] === null || requestParameters['supportCreateClaimEligibilityPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimEligibilityPayload','Required parameter requestParameters.supportCreateClaimEligibilityPayload was null or undefined when calling createSupportClaimEligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eligibility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eligibility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimEligibilityPayloadToJSON(requestParameters['supportCreateClaimEligibilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Create a claim eligibility
     * Create a claim eligibility
     */
    async createSupportClaimEligibility(requestParameters: CreateSupportClaimEligibilityRequest): Promise<SupportClaimEligibility> {
        const response = await this.createSupportClaimEligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate a claim eligibility
     * Generate a claim eligibility
     */
    async generateSupportClaimEligibilityRaw(requestParameters: GenerateSupportClaimEligibilityRequest): Promise<runtime.ApiResponse<SupportClaimEligibility>> {
        if (requestParameters['supportGenerateClaimEligibilityPayload'] === null || requestParameters['supportGenerateClaimEligibilityPayload'] === undefined) {
            throw new runtime.RequiredError('supportGenerateClaimEligibilityPayload','Required parameter requestParameters.supportGenerateClaimEligibilityPayload was null or undefined when calling generateSupportClaimEligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eligibility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eligibility/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportGenerateClaimEligibilityPayloadToJSON(requestParameters['supportGenerateClaimEligibilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Generate a claim eligibility
     * Generate a claim eligibility
     */
    async generateSupportClaimEligibility(requestParameters: GenerateSupportClaimEligibilityRequest): Promise<SupportClaimEligibility> {
        const response = await this.generateSupportClaimEligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a claim eligibility
     * Get a claim eligibility
     */
    async getProviderClaimEligibilityRaw(requestParameters: GetProviderClaimEligibilityRequest): Promise<runtime.ApiResponse<ProviderClaimEligibility>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClaimEligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eligibility"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eligibility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Gets a claim eligibility
     * Get a claim eligibility
     */
    async getProviderClaimEligibility(requestParameters: GetProviderClaimEligibilityRequest): Promise<ProviderClaimEligibility> {
        const response = await this.getProviderClaimEligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a claim eligibility
     * Get a claim eligibility
     */
    async getSupportClaimEligibilityRaw(requestParameters: GetSupportClaimEligibilityRequest): Promise<runtime.ApiResponse<SupportClaimEligibility>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClaimEligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eligibility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eligibility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Gets a claim eligibility
     * Get a claim eligibility
     */
    async getSupportClaimEligibility(requestParameters: GetSupportClaimEligibilityRequest): Promise<SupportClaimEligibility> {
        const response = await this.getSupportClaimEligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claims eligibilities
     * Get a list of claim eligibilities
     */
    async listProviderClaimEligibilitiesRaw(requestParameters: ListProviderClaimEligibilitiesRequest): Promise<runtime.ApiResponse<Array<ProviderClaimEligibility>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterPlanId) {
            queryParameters['filterPlanId'] = requestParameters.filterPlanId;
        }

        if (requestParameters.filterGroupId) {
            queryParameters['filterGroupId'] = requestParameters.filterGroupId;
        }

        if (requestParameters.filterTypeParameter) {
            queryParameters['filterTypeParameter'] = requestParameters.filterTypeParameter;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eligibility"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eligibility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClaimEligibilityFromJSON));
    }

    /**
     * Gets a list of claims eligibilities
     * Get a list of claim eligibilities
     */
    async listProviderClaimEligibilities(requestParameters: ListProviderClaimEligibilitiesRequest): Promise<Array<ProviderClaimEligibility>> {
        const response = await this.listProviderClaimEligibilitiesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claims eligibilities
     * Get a list of claim eligibilities
     */
    async listSupportClaimEligibilitiesRaw(requestParameters: ListSupportClaimEligibilitiesRequest): Promise<runtime.ApiResponse<Array<SupportClaimEligibility>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterPlanId) {
            queryParameters['filterPlanId'] = requestParameters.filterPlanId;
        }

        if (requestParameters.filterGroupId) {
            queryParameters['filterGroupId'] = requestParameters.filterGroupId;
        }

        if (requestParameters.filterTypeParameter) {
            queryParameters['filterTypeParameter'] = requestParameters.filterTypeParameter;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eligibility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eligibility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimEligibilityFromJSON));
    }

    /**
     * Gets a list of claims eligibilities
     * Get a list of claim eligibilities
     */
    async listSupportClaimEligibilities(requestParameters: ListSupportClaimEligibilitiesRequest): Promise<Array<SupportClaimEligibility>> {
        const response = await this.listSupportClaimEligibilitiesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace an eligibility
     * Replace an eligibility
     */
    async replaceSupportEligibilityRaw(requestParameters: ReplaceSupportEligibilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceEligibilityPayload'] === null || requestParameters['supportReplaceEligibilityPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceEligibilityPayload','Required parameter requestParameters.supportReplaceEligibilityPayload was null or undefined when calling replaceSupportEligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:eligibility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eligibility/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceEligibilityPayloadToJSON(requestParameters['supportReplaceEligibilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace an eligibility
     * Replace an eligibility
     */
    async replaceSupportEligibility(requestParameters: ReplaceSupportEligibilityRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportEligibilityRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderClaimEligibilitiesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClaimEligibilitiesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
